import { Component, signal } from '@angular/core';
import { StorefrontComponent } from '@spartacus/storefront';
import { PagesService } from './pages/pages.service';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [StorefrontComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class App {
  protected readonly title = signal('CHiME Agent');
  
  constructor(
    private pagesService: PagesService,
    private titleService: Title,
    private router: Router
  ) {
    // Set the browser tab title on app initialization
    this.titleService.setTitle('CHiME Agent');
  }

  ngOnInit() {
    // Reset title after each navigation (Spartacus PageTitleModule tries to override it)
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        // Use setTimeout with 0 delay to ensure this runs AFTER Spartacus sets its title
        setTimeout(() => {
          this.titleService.setTitle('CHiME Agent');
        }, 0);
      });
  }
}
